module.exports = __webpack_public_path__ + "img/bg_main_t.006fe720.png";